import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Hub from '../../components/hub/Hub';

function Dashboard() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <Hub
      username={user.username}
      role={user.role}
      permissions={user.permissions ?? []}
      canViewCards={(user.permissions ?? []).includes('avengers-cards')}
      onLogout={handleLogout}
    />
  );
}

export default Dashboard;
